export const OPEN_MENU = 'OPEN_MENU';
export const OPEN_INFO = 'OPEN_INFO';
export const SETTINGS_OPEN = 'SETTINGS_OPEN';
export const CHANGE_SETTINGS = 'CHANGE_SETTINGS';
export const REFRESH = 'REFRESH';
export const PUSH_CURRENT = 'PUSH_CURRENT';
export const OPEN_CLOSE_FILE = 'OPEN_FILE';
export const OPEN_TERMINAL = 'OPEN_TERMINAL';
export const FIRE_COMMAND = 'FIRE_COMMAND';
